<template>
  <section class="text-black pt-14" id="locs">
    <div class="contain mx-auto mb-8">
      <div class="w-full">
        <h2
          class="w-full font-belgiano font-medium md:text-[2.6rem] md:leading-[3rem] text-5xl text-black"
        >
          There is a charge Station Near you
        </h2>
        <div class="flex items-end justify-between">
          <div class="flex items-end">
            <div class="w-full flex items-stretch gap-6 mt-8">
              <ViewButtons
                :clickFunction="clickFunction"
                :view="view"
                :views="VIEWS"
              />
            </div>
          </div>
          <div
            class="relative"
            @mouseenter="showFilters = true"
            @mouseleave="
              showFilters = false;
              filterType = '';
            "
          >
            <button
              class="flex items-center gap-2 font-inter border border-[#F5F5F5] rounded-md py-2 px-4"
              @click="showFilters = !showFilters"
              type="button"
            >
              <FilterIcon /> <span>Filters</span>
            </button>
            <div
              v-show="showFilters"
              class="absolute right-0 top-0 mt-2 min-w-48 bg-white border border-gray-200 rounded-md shadow-lg transition-opacity z-20 py-2"
            >
              <div class="w-full flex items-center jsutify-end">
                <button
                  class="ml-auto p-1 rounded hover:bg-gray-100"
                  @click="
                    showFilters = false;
                    filterType = '';
                  "
                  aria-label="Close filters"
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <ul v-if="!filterType">
                <li
                  class="cursor-pointer flex items-center justify-between hover:bg-newGrey hover:bg-opacity-20 pr-2"
                  @click="filterType = 'charger_type'"
                >
                  <span class="block text-sm px-4 py-2">Charger Type</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="inline h-4 w-4 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </li>
                <li
                  class="cursor-pointer flex items-center justify-between hover:bg-newGrey hover:bg-opacity-20 pr-2"
                  @click="filterType = 'connector_type'"
                >
                  <span class="block text-sm px-4 py-2">Connector Type</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="inline h-4 w-4 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </li>
                <li class="px-4">
                  <input
                    type="number"
                    class="w-full text-sm placeholder:text-xs border border-[#F5F5F5] rounded-md py-2 px-1 outline-none"
                    placeholder="Search by distance (km)"
                    v-model="filters.radius"
                  />
                </li>
              </ul>
              <ul v-else-if="filterType === 'charger_type'">
                <li
                  v-for="charger in Object.keys(chargersType)"
                  :key="charger"
                  class="cursor-pointer text-sm px-4 py-2 hover:bg-newGrey hover:bg-opacity-20"
                  @click="
                    filters.charger_type = charger;
                    showFilters = false;
                    filterType = '';
                  "
                >
                  {{
                    charger.toLowerCase() === "dc" ? "Fast Charger" : charger
                  }}
                </li>
              </ul>
              <ul v-else-if="filterType === 'connector_type'">
                <li
                  v-for="charger in filters.charger_type
                    ? chargersType[filters.charger_type]
                    : [...chargersType.AC, ...chargersType.DC]"
                  :key="charger"
                  class="cursor-pointer text-sm px-4 py-2 hover:bg-newGrey hover:bg-opacity-20"
                  @click="
                    filters.connector_type = charger;
                    showFilters = false;
                    filterType = '';
                  "
                >
                  {{ charger }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="flex items-end gap-2 mt-4">
          <span
            v-for="[key, value] in Object.entries(filters).filter(
              ([_, v]) => v
            )"
            :key="key"
            class="flex items-center text-xs font-medium text-gray-700 border border-[#F5F5F5] rounded-md px-4 py-2"
          >
            <span class="capitalize">
              {{ key === "radius" ? "Within" : "" }}
              {{
                key === "charger_type" && value.toLowerCase() === "dc"
                  ? "Fast Charger"
                  : key === "charger_type" && value.toLowerCase() === "ac"
                  ? "AC Charger"
                  : value.replace("_", " ")
              }}
              <!-- {{ value.replace("_", " ") }} -->
              {{ key === "radius" ? "KM" : "" }}
            </span>
            <button
              class="ml-2 text-gray-400 hover:text-gray-700 cursor-pointer"
              @click="filters[key] = ''"
              type="button"
              aria-label="Remove filter"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </span>
        </div>
      </div>
    </div>
    <!-- CHARGE STATIONS FILTER -->
    <LeafLetMap
      v-if="!loading && view === VIEWS.MAP"
      :stations="chargeStations"
      :userLongLat="userLocation"
    />
    <!-- <MapView :stations="stations" v-if="view === VIEWS.MAP" /> -->
    <ListView :stations="chargeStations" v-if="view === VIEWS.LIST" />
    <ScheduleModal
      :sliderOpen="scheduleOpen"
      :closeSlider="closeSlider"
      :stations="chargeStations"
    />
  </section>
</template>

<script>
import ListView from "./ListView.vue";
import LeafLetMap from "./LeafLetMap/Index.vue";
import MapView from "./MapView/Index.vue";
import ScheduleModal from "./ScheduleModal.vue";

import ViewButtons from "./ViewButtons.vue";
import FilterIcon from "./FilterIcon.vue";
const VIEWS = {
  MAP: "map",
  LIST: "list",
};
const chargersType = {
  AC: ["Type 1", "Type 2", "Tesla"],
  DC: ["GBT", "CCS2"],
};

// const stations = [
//   {
//     id: "ikeja-electric",
//     y: 78,
//     x: 556,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Ikeja Electric Station",
//       address: "78 Obafemi Awolowo Way, Ikeja, Lagos State",
//       chargers: "1 DC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "ikoyi",
//     y: 833,
//     x: 968,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Ikoyi Station",
//       address: "12 Bourdillon Road, Ikoyi, Lagos State",
//       chargers: "1 AC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "yaba",
//     y: 521,
//     x: 711,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Yaba Station",
//       address: "260/262 Herbert Macaulay Way, Yaba, Lagos State",
//       chargers: "2 AC Chargers",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "marina",
//     y: 839,
//     x: 779,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Marina Station",
//       address: "20 Marina Road, Lagos State",
//       chargers: "2 AC & 1 DC Chargers",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "adeola-odeku",
//     y: 944,
//     x: 890,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Adeola Odeku Station",
//       address: "300 Adeola Odeku, Victoria Island, Lagos State",
//       chargers: "1 AC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "sheraton-ikeja",
//     y: 175,
//     x: 632,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Sheraton Hotel, Ikeja Station",
//       address: "30 Mobolaji Bank Anthony Way, Ikeja, Lagos State",
//       chargers: "1 DC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "ilupeju",
//     y: 333,
//     x: 652,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Ilupeju Station",
//       address: "H946+6HF, Ilupeju, Lagos State",
//       chargers: "2 AC Chargers",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "marriot-ikeja",
//     y: 129,
//     x: 623,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Marriot Hotel, Ikeja Station",
//       address: "22 Joel Ogunnaike, Ikeja, Lagos State",
//       chargers: "1 DC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
//   {
//     id: "ikeja",
//     y: 169,
//     x: 578,
//     img: require("@/assets/images/map/basemap.png"),
//     details: {
//       name: "Ikeja Station",
//       address: "2 Opebi Road, Ikeja, Lagos State",
//       chargers: "1 AC Charger",
//       openHours: "Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM",
//     },
//   },
// ];

export default {
  setup() {
    return {
      VIEWS,
      chargersType,
      // stations,
    };
  },
  name: "ChargeStationMap",
  components: {
    LeafLetMap,
    ViewButtons,
    MapView,
    ListView,
    ScheduleModal,
    FilterIcon,
    // Register your components here
  },
  computed: {
    // Define your computed properties here
    scheduleOpen() {
      return this.$store.getters.isScheduleOpen;
    },
    filterQueryString() {
      const filterParams = Object.entries(this.filters)
        .filter(([_, value]) => value) // Filter out empty values
        .map(([key, value]) => `${key}=${value}`);

      if (this.userLocation && this.userLocation.length === 2) {
        filterParams.push(`lat=${this.userLocation[0]}`);
        filterParams.push(`lon=${this.userLocation[1]}`);
        if (!this.filters.radius) {
          filterParams.push(`radius=50`); // Default radius if not set
        }
      }

      return filterParams.join("&");
    },
  },
  data() {
    return {
      // Define your data properties here
      view: VIEWS.MAP,
      userLocation: null,
      chargeStations: null,
      loading: true,
      showFilters: false,
      filterType: "", // Default filter type
      filters: {
        charger_type: "",
        connector_type: "",
        radius: "", // Default radius in km
      },
    };
  },
  methods: {
    // Define your methods here
    clickFunction(view) {
      this.view = view;
    },
    closeSlider() {
      this.$store.commit("setOpenSchedule", false);
      this.$store.commit("setSelectedStation", "");
    },
    getStationsNoFilter() {
      fetch(process.env.VUE_APP_API_URL + "/charge-stations", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(async (response) => {
          this.chargeStations = response.data;
          // console.log("HERE");
          
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    // Any mounted logic can go here
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = [
          position.coords.latitude,
          position.coords.longitude,
        ];
        // alert("User's location: " + JSON.stringify(userLocation));
        // console.log(position);

        // alert(JSON.stringify(userLocation));
        this.userLocation = userLocation;
        // Now use this to fetch nearby stations

        fetch(
          process.env.VUE_APP_API_URL +
            "/charge-stations" +
            (this.filterQueryString.length ? "?" + this.filterQueryString : ""),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then(async (response) => {
            if (response.data.length) {
              this.chargeStations = response.data.sort(
                (a, b) =>
                  (a.distance_from_user || 0) - (b.distance_from_user || 0)
              );
              // console.log(this.chargeStations);
              
              this.loading = false;
            } else {
              this.getStationsNoFilter();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      (error) => {
        this.getStationsNoFilter();
        alert("Unable to get user's location.");
        console.error("Geolocation error:", error);
      }
    );
  },
  watch: {
    filterQueryString(newVal) {
      // Fetch stations whenever the filter query string changes
      this.loading = true;
      fetch(
        process.env.VUE_APP_API_URL +
          "/charge-stations" +
          (newVal.length ? "?" + newVal : ""),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then(async (response) => {
          this.chargeStations = response.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>